'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _componentProvider = require('@spp/component-provider');

var _themeProvider = require('@spp/theme-provider');

var _Article = require('./Article');

var _Article2 = _interopRequireDefault(_Article);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _componentProvider.withComponentMapping)((0, _themeProvider.themer)('@spp/ui-article')(_Article2.default));
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/article/lib/cjs/index.js
 ** module id = 471
 ** module chunks = 1
 **/